export default __webpack_public_path__ + "static/media/cart.3720f3df.svg";